import React, { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import Link from '@material-ui/core/Link';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/styles';

import { Button } from '@components';
// import { PayModal } from '@views/Payments/PayModal';
import { WireTransferModal } from '@views/Payments/WireTransferModal';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './ChoosePaymentOption.json';
import { LANGUAGES } from '@helpers';

const useStyles = makeStyles(() => ({
  button: {
    lineHeight: '20px !important',
  },
  wireTransferButton: {
    color: 'var(--Grayscale-Nero, #1B1B1B)',
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: '300',
    lineHeight: '24px',
    letterSpacing: ' -0.14px',
    '@media screen and (max-width: 700px)': {
      marginLeft: '7px',
    },
  },
}));

export const ChoosePaymentOption = ({
  onPayWithBankTransferClick,
  onPayWithCreditCardClick,
  orderId,
  availableReservationLimit = 0,
  selectedAmount = { amount: 0, currency: 'USD' },
}) => {
  // const [isPlaidDialogOpen, setIsPlaidDialogOpen] = useState(false);
  const [isWireTransferDialogOpen, setShowWireTransfer] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';
  const searchParams = new URLSearchParams(window.location.search);
  const paymentProcessor =
    searchParams.get('processor') ||
    process.env.REACT_APP_STRIPE_PAYMENT_METHOD;
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={4}>
        {/* {paymentProcessor !== 'ach' && (
          <Grid item xs={12}>
            <Typography variant="body2">
              {l(content.paySecurely, language)}
              {language === LANGUAGES.en.drupalLangcode ? (
                <Link
                  style={{ fontSize: 'inherit', color: 'inherit' }}
                  onClick={() => setIsPlaidDialogOpen(true)}
                >
                  {l(content.plaidLink, language)}
                </Link>
              ) : null}
              {l(content.payNoShare, language)}
            </Typography>
          </Grid>
        )} */}
        {isMobile ? (
          <Box>
            <Grid container>
              <Grid item xs={12}>
                {/* {availableReservationLimit > 0 && (
                  <>
                    <Grid item xs={12}>
                      <Button
                        data-cy="data-pay-with-credit-card-button"
                        onClick={onPayWithCreditCardClick}
                        text={l(content.payCreditCard, language)}
                        hoverColor="#555354"
                        data-pay-with-bank-transfer
                        height="64px"
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        data-cy="data-pay-with-bank-transfer-button"
                        onClick={onPayWithBankTransferClick}
                        text={l(content.bankTransfer, language)}
                        hoverColor="#555354"
                        data-pay-with-bank-transfer
                        height="64px"
                      />
                    </Grid>
                  </>
                )} */}
                <Grid item xs={12} style={{ margin: '20px' }}>
                  <Link
                    data-cy="data-pay-with-check-or-wire-transfer"
                    onClick={() => setShowWireTransfer(true)}
                    data-pay-with-check-or-wire-transfer
                    className={classes.wireTransferButton}
                  >
                    {l(content.wireTransfer, language)}
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        ) : (
          <Grid item xs={12} container alignItems="center" spacing={8}>
            {/* {availableReservationLimit > 0 && (
              <>
                <Grid item xs={8}>
                  <Button
                    data-cy="data-pay-with-credit-card-button"
                    onClick={onPayWithCreditCardClick}
                    text={l(content.payCreditCard, language)}
                    hoverColor="#555354"
                    data-pay-with-bank-transfer
                    className={classes.button}
                    disabled={
                      selectedAmount.amount < 1 || selectedAmount.amount > 5000
                    }
                  />
                </Grid>
                <Grid item xs={8}>
                  <Button
                    data-cy="data-pay-with-bank-transfer-button"
                    onClick={onPayWithBankTransferClick}
                    text={l(content.bankTransfer, language)}
                    hoverColor="#555354"
                    data-pay-with-bank-transfer
                    className={classes.button}
                    disabled={
                      selectedAmount.amount < 1 || selectedAmount.amount > 15000
                    }
                  />
                </Grid>
              </>
            )} */}
            <Grid item xs={8}>
              <Link
                data-cy="data-pay-with-check-or-wire-transfer"
                onClick={() => setShowWireTransfer(true)}
                data-pay-with-check-or-wire-transfer
                className={classes.wireTransferButton}
              >
                {l(content.wireTransfer, language)}
              </Link>
            </Grid>
          </Grid>
        )}
      </Grid>
      {/* 
      <PayModal
        onClose={() => setIsPlaidDialogOpen(false)}
        open={isPlaidDialogOpen}
      /> */}

      <WireTransferModal
        onClose={() => setShowWireTransfer(false)}
        open={isWireTransferDialogOpen}
        orderId={orderId}
      />
    </>
  );
};
